import Pagination from '../Pagination'
import Sort from '../SortReq'

export default function (other) {
  other = other || {}
  return {
    id: other.id || null,
    title: other.title || null,
    types: other.types || [],
    statuses: other.statuses || [],
    priorities: other.priorities || [],
    assigneeUserId: other.assigneeUserId || null,
    createdBy: other.createdBy || null,
    orgIds: other.orgIds || [],
    relatedModule: other.relatedModule || null,
    relatedId: other.relatedId || null,
    creationTimeStart: other.creationTimeStart || null,
    creationTimeEnd: other.creationTimeEnd || null,
    dueBefore: other.dueBefore || null,
    search: other.search || null,
    pagination: other.pagination || Pagination(),
    sort: other.sort || Sort(),
  }
}
